import request, { baseURL } from '@/utils/request/index'
import axios from 'axios'
import { UserModule } from '@/store/modules/user'
import {
  IUserInfo,
  LoginFormData,
  UserInfo,
} from '@/api/user/type'

// 查: 用户名是否可用
export const checkUsernameCanUse = (username: string) =>
  request.get<null>('/api/sys/user/checkUsername', {
    params: { username },
    baseURL
  })

export const getCaptchaSrc = () => request.get<Blob>('/api/system/captcha', { responseType: 'blob' })

// 查: 通过 Cookie 查询登录用户的信息
export const getUserInfo = () =>
  request<UserInfo>({
    url: '/api/system/userinfo',
    method: 'get'
  })

export const login = (data: LoginFormData) =>
  request<string>({ // 登录成功返回 token
    url: '/api/system/login',
    method: 'post',
    data
  })

export const logout = () =>
  request({
    url: '/api/system/logout',
    method: 'get',
  })

/**
 * 通过获取用户信息接口判断 token 是否有效
 * 如果有效则借助该接口对用户信息进行拉取
 * 如果失效则会通过在响应拦截器中抛异常
 * 1 次调用完成两件事情
 */
export function checkIsTokenValid (token: string) {
  return axios.get('/api/system/userinfo', {
    baseURL,
    headers: { Authorization: token }
  })
    .then((res) => {
      // TODO: 将该部分操作拆分到 login 钩子中
      UserModule.UpdateUserInfo({
        ...res.data.data,
      })
    })
    .then(() => true)
    .catch(() => false) // 鉴权失败时 HTTP Status 是 401
}
